import { IGetState, TCardId } from '../../../../../types/types';
import { IDriveDoc } from '../../../../../store/model/card/types/IDriveDoc';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { Util } from '../../../../../util/util';
import { REST_CARD } from '../../../../constants';
import { getRestHeadersPatch } from '../../../../helpers/getRestHeadersHelper';

export const patchDriveDocsRest = (
    cardId: TCardId,
    driveDocs: IDriveDoc[]
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IDriveDoc[]>(
            Util.getApiUrl(`${REST_CARD}${cardId}/drivedocs`),
            {
                ...getRestHeadersPatch(),
                body: JSON.stringify(driveDocs)
            }
        );
    };
    return action;
};
